export default __webpack_public_path__ + "static/media/rectangle-org.7fa57d3e.png";